
import React, { PureComponent } from 'react'
import { Field } from 'redux-form'
import { Panel, Row, Tab, Tabs } from 'react-bootstrap'
import InputSelect from '../../commons/form/InputSelect'
import InputDatePicker from '../../commons/form/InputDatePicker'
import InputMoney from '../../commons/form/InputMoney'
import InputPercentage from '../../commons/form/InputPercentage'
import InputText from '../../commons/form/InputText'
import InputCheckBox from '../../commons/form/InputCheckBox'
import { validateDate } from '../../../util/validationFunctions'
import { permissions } from '../../../constants/backendIds'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import CampaignsPopover from '../common/CampaignsPopover'
import { campaignField, campaignType } from '../../../constants/dossier/common/campaignType'
import { dossierSubTypeId as dossierSubTypeIdConstants } from '../../../constants/dossier/common/dossierSubType'
import { compareObjects } from '../../../util/utils'
import CustomFields from '../../commons/customFields/CustomFields'

class CampaignComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      campaignIsActive: null,
      open: false,
      documentIds: true,
      checklistEditable: true,
      cost: 0,
      costConcession: 0,
      fieldsConfiguration: {
        campaignTypeId: {
          permission: null
        },
        approvalDate: {
          permission: null
        },
        amountPercentage: {
          permission: null
        },
        costPercentage: {
          permission: null
        },
        costConcession: {
          permission: null
        },
        costConcessionPercentage: {
          permission: null
        },
        popOverCampaings: {
          permission: null
        },
        amount: {
          permission: null
        },
        cost: {
          permission: null
        },
        documentIds: {
          permission: null
        },
        startDate: {
          permission: null
        },
        endDate: {
          permission: null
        },
        orderDate: {
          permission: null
        },
        amountCampaign: {
          permission: null
        },
        amountBrand: {
          permission: null
        },
        percentageCampaign: {
          permission: null
        },
        percentageBrand: {
          permission: null
        },
        amountRequested: {
          permission: null
        },
        approvedAmount: {
          permission: null
        },
        bonified: {
          permission: null
        },
        observations: {
          permission: null
        },
        campaignDetailsId: {
          permission: null
        },
        amountCost: {
          permission: null
        },
        responsable: {
          permission: null
        },
        billingNumber: {
          permission: null
        },
        billingDate: {
          permission: null
        },
        vehiclePrice: {
          permission: null
        },
        vehicleOptionalsPrice: {
          permission: null
        },
        expirationDate: {
          permission: null
        },
        percentageRequested: {
          permission: null
        },
        percentageApproved: {
          permission: null
        },
        checkInvoiceProform: {
          permission: null
        },
        checkBillingRequested: {
          permission: null
        },
        paymentMethodCampaign: {
          permission: null
        },
        name: {
          permission: null
        }
      }
    }
  }

  handleCampaign (campaignTypeId) {
    this.props.actions.change('dossierCampaignComponent.documentIds', [])
    if (campaignTypeId) {
      this.props.actions.fetchChecklistCampaign(campaignTypeId, this.props.dossier.organizedUnitId)
      this.setState({ documentIds: false })
    } else {
      this.setState({ documentIds: true })
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  componentDidMount () {
    if (this.props.componentConfiguration !== null) {
      this.initializePermisions(this.props)
    } else {
      this.setState({ permission: 0 })
    }
    this.setState({ cost: this.props.dossier.dossierCampaignComponent.cost, costConcession: this.props.dossier.dossierCampaignComponent.costConcession })
  }

  componentDidUpdate () {
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (!this.state.open) {
      this.setState({ open: true })
      if (this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden ||
        this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden ||
        this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden) {
        if (this.props.dossier.dossierCampaignComponent.setActiveTab === 2) {
          this.setState({ tabActiveKey: 2 })
          this.props.actions.savePercentages(2)
        } else {
          this.setState({ tabActiveKey: 1 })
          this.props.actions.savePercentages(1)
        }
      }
    }

    if (this.props.dossier.dossierCampaignComponent !== prevProps.dossier.dossierCampaignComponent) {
      this.setState({ documentIds: !this.props.dossier.dossierCampaignComponent.campaignTypeId })
    }

    if (this.props.dossier && this.props.dossier.dossierId && !compareObjects(prevProps.componentConfiguration || {}, this.props.componentConfiguration, true)) {
      this.initializePermisions(this.props)
    }

    return prevProps
  }

  setCost (value) {
    let cost = this.setValue('cost', value)
    this.setState({ cost: cost })
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.calculateAmount(cost, this.state.costConcession)
    }
  }

  setValue (field, value) {
    let total = 0
    if (this.props.dossier.totalAmountWithOptionals) {
      total = (((this.props.dossier.totalAmountWithOptionals) * value) / 100).toFixed(2)
    }
    this.props.change('dossierCampaignComponent.' + field, total)
    return total
  }

  setPercentage (field, value) {
    let total = 0
    if (this.props.dossier.totalAmountWithOptionals) {
      total = ((value * 100) / (this.props.dossier.totalAmountWithOptionals)).toFixed(2)
    }
    this.props.change('dossierCampaignComponent.' + field, total)
  }

  setCostConcession (value) {
    let costConcession = this.setValue(campaignField.COST_CONCESSION, value)
    this.setState({ costConcession: costConcession })
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.calculateAmount(this.state.cost, costConcession)
    }
  }

  handleBlurCost (event) {
    if (this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden) {
      this.setPercentage(campaignField.COST_PERCENTAGE, event)
    }
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.setState({ cost: event })
      this.calculateAmount(event, this.state.costConcession)
    }
  }

  handleBlurCostConcession (event) {
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.setState({ costConcession: event })
      this.calculateAmount(this.state.cost, event)
    }
    if (this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden) {
      this.setPercentage(campaignField.COST_CONCESSION_PERCENTAGE, event)
    }
  }

  handleBlurAmount (event) {
    if (this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden) {
      this.setPercentage(campaignField.AMOUNT_PERCENTAGE, event)
    }
  }

  handleBlurAmountPercentage (event) {
    if (this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden) {
      this.setValue(campaignField.AMOUNT, event)
    }
  }

  handleBlurCostPercentage (event) {
    if (this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden) {
      this.setCost(event)
    }
  }

  handleBlurCostConcessionPercentage (event) {
    if (this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden) {
      this.setCostConcession(event)
    }
  }

  calculateAmount (cost, costConcession) {
    this.props.actions.change('dossierCampaignComponent.amount', parseFloat(cost) + parseFloat(costConcession))
    this.handleBlurAmount(parseFloat(cost) + parseFloat(costConcession))
  }

  dateValidation (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  changeDetails (detailsId, dossierId) {
    if (dossierId !== null) {
      this.props.actions.fetchCampaignDetails(dossierId, detailsId)
      const cam = this.props.combos.campaignDetails && this.props.combos.campaignDetails.find(val => val.id === detailsId)
      if (cam) {
        this.props.actions.fetchCampaignActive(cam.active)
      }
    }
  }

  changeAmount (value) {
    let total = 0
    if (this.props.dossier.totalAmountWithOptionalsPurchase) {
      total = (((this.props.dossier.totalAmountWithOptionalsPurchase) * value) / 100).toFixed(2)
    }
    this.props.actions.change('dossierCampaignComponent.dossierCampaignDetailComponent.amountRequested', total)
  }

  changeAmountApproved (value) {
    let total = 0
    if (this.props.dossier.totalAmountWithOptionalsPurchase) {
      total = (((this.props.dossier.totalAmountWithOptionalsPurchase) * value) / 100).toFixed(2)
    }
    this.props.actions.change('dossierCampaignComponent.dossierCampaignDetailComponent.approvedAmount', total)
  }

  cancelDrag (event) {
    event.preventDefault()
    return false
  }

  render () {
    const { t, readOnlyFields, campaignOpen, customFields, combos: { paymentMethodCampaignCombo, campaignsTypes, documentsTypes, campaignDetails }, actions: { togglePanel }, dossier: { dossierId, dossierCampaignComponent: { checklistEditable, dossierCampaignDetailComponent: { amountFreeOption, percentageFreeOption }, filledBillingDateAndNumberInParent }, dossierSubTypeId } } = this.props
    const tKey = 'DOSSIER_COMPONENTS.'
    return (
      <Row className="campaign-panel dossier-panel">
        <div className="header-panel" onClick={togglePanel}>
          <div className="name-wrapper">
            <i className="ico-car-files" />
            <h4>{dossierSubTypeId === dossierSubTypeIdConstants.campanya_ayuda_especial ? t(`${tKey}SPECIAL_HELP_DOSSIER.CAMPAIGN_COMPONENT.TITLE`) : t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.TITLE`)}</h4>
          </div>
          <i className={campaignOpen ? 'ico-arrow-black-up' : 'ico-arrow-black-down'} />
        </div>
        <Panel expanded={campaignOpen} onToggle={() => {}}>
          <Panel.Collapse>
            <Row>
              {this.state.fieldsConfiguration.name.permission !== permissions.hidden && (
                <Field
                  colSm={12}
                  id="name"
                  name="dossierCampaignComponent.name"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.NAME`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.NAME`)}
                  component={InputText}
                  disabled={this.state.fieldsConfiguration.name.permission !== permissions.editable}
                />
              )}
              {this.state.fieldsConfiguration.responsable.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="responsable"
                  name="dossierCampaignComponent.responsable"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.RESPONSABLE`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.RESPONSABLE`)}
                  component={InputText}
                  disabled={true}
                />
              )}
              {this.state.fieldsConfiguration.campaignTypeId.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="campaignTypeId"
                  name="dossierCampaignComponent.campaignTypeId"
                  controlLabel={dossierSubTypeId === dossierSubTypeIdConstants.campanya_ayuda_especial ? t(`${tKey}SPECIAL_HELP_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_TYPE`) : t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_TYPE`)}
                  placeholder={dossierSubTypeId === dossierSubTypeIdConstants.campanya_ayuda_especial ? t(`${tKey}SPECIAL_HELP_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_TYPE`) : t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_TYPE`)}
                  component={InputSelect}
                  options={campaignsTypes}
                  valueKey="id"
                  labelKey="value"
                  disabled={readOnlyFields}
                />)}
              {this.state.fieldsConfiguration.campaignDetailsId.permission !== permissions.hidden && (
                <Field
                  id="campaignDetailsId"
                  name="dossierCampaignComponent.campaignDetailsId"
                  colSm={6}
                  controlLabel= {this.props.dossier.dossierSubTypeId === campaignType.SPECIAL ? t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.HELP_TYPE`) : t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_TYPE`) }
                  placeholder= {this.props.dossier.dossierSubTypeId === campaignType.SPECIAL ? t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.HELP_TYPE`) : t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_TYPE`) }
                  component={InputSelect}
                  valueKey="id"
                  labelKey="value"
                  options={campaignDetails}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.campaignDetailsId.permission === permissions.readOnly}
                  onChange={(event, value) => this.changeDetails(value, dossierId, event)}
                  onlyVisible= {!(readOnlyFields || this.state.fieldsConfiguration.campaignDetailsId.permission === permissions.readOnly)}
                />)}

              {this.state.fieldsConfiguration.startDate.permission !== permissions.hidden && (
                <Field
                  id="startDate"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.startDate"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.START_DATE`)}
                  component={InputDatePicker}
                  disabled={true}
                />
              )}
              {this.state.fieldsConfiguration.endDate.permission !== permissions.hidden && (
                <Field
                  id="endDate"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.endDate"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.END_DATE`)}
                  component={InputDatePicker}
                  disabled={true}
                />
              )}
              {this.state.fieldsConfiguration.orderDate.permission !== permissions.hidden && (
                <Field
                  id="orderDate"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.orderDate"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.ORDER_DATE`)}
                  component={InputDatePicker}
                  disabled={true}
                />
              )}
              {this.state.fieldsConfiguration.approvalDate.permission !== permissions.hidden && (
                <Field
                  id="ApprovalDate"
                  name="dossierCampaignComponent.approvalDate"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.APPROVAL_DATE`)}
                  component={InputDatePicker}
                  validate={[this.dateValidation]}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.approvalDate.permission === permissions.readOnly}
                />)}
              {this.state.fieldsConfiguration.amountCampaign.permission !== permissions.hidden && (
                <Field
                  id="amountCampaign"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.amountCampaign"
                  type="text"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_CAMPAIGN`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_CAMPAIGN`)}
                  component={InputMoney}
                  disabled={true}
                />)}
              {this.state.fieldsConfiguration.amountBrand.permission !== permissions.hidden && (
                <Field
                  id="amountBrand"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.amountBrand"
                  type="text"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_BRAND`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_BRAND`)}
                  component={InputMoney}
                  disabled={true}
                />)}
              {this.state.fieldsConfiguration.percentageCampaign.permission !== permissions.hidden && (
                <Field
                  id="percentageCampaign"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.percentageCampaign"
                  type="text"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_PERCENTAGE`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CAMPAIGN_PERCENTAGE`)}
                  component={InputPercentage}
                  disabled={true}
                />)}
              {this.state.fieldsConfiguration.percentageBrand.permission !== permissions.hidden && (
                <Field
                  id="percentageBrand"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.percentageBrand"
                  type="text"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.BRAND_PERCENTAGE`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.BRAND_PERCENTAGE`)}
                  component={InputPercentage}
                  disabled={true}
                />)}
              <Row className='rowNotMargin'>
                {this.state.fieldsConfiguration.percentageRequested.permission !== permissions.hidden && (
                  <Field
                    id="percentageCampaignRequested"
                    name="dossierCampaignComponent.dossierCampaignDetailComponent.percentageCampaignRequested"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.PERCENTAGE_REQUESTED`)}
                    placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.PERCENTAGE_REQUESTED`)}
                    component={InputPercentage}
                    disabled={readOnlyFields || (!percentageFreeOption || this.state.fieldsConfiguration.percentageRequested.permission === permissions.readOnly)}
                    onInputBlur={(component) => this.changeAmount(component)}
                  />)}
                {(this.state.fieldsConfiguration.percentageApproved.permission !== permissions.hidden) && (
                  <Field
                    id="percentageCampaignApproved"
                    name="dossierCampaignComponent.dossierCampaignDetailComponent.percentageCampaignApproved"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.PERCENTAGE_APPROVED`)}
                    placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.PERCENTAGE_APPROVED`)}
                    component={InputPercentage}
                    disabled={readOnlyFields || (!percentageFreeOption || this.state.fieldsConfiguration.percentageApproved.permission === permissions.readOnly)}
                    onInputBlur={(component) => this.changeAmountApproved(component)}
                  />)}
              </Row>
              <Row className='rowNotMargin'>
                {this.state.fieldsConfiguration.amountRequested.permission !== permissions.hidden && (
                  <Field
                    id="amountRequested"
                    name="dossierCampaignComponent.dossierCampaignDetailComponent.amountRequested"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_FREE`)}
                    placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_FREE`)}
                    component={InputMoney}
                    disabled={readOnlyFields || !amountFreeOption || this.state.fieldsConfiguration.amountRequested.permission === permissions.readOnly}
                  />)}
                {this.state.fieldsConfiguration.approvedAmount.permission !== permissions.hidden && (
                  <Field
                    id="approvedAmount"
                    name="dossierCampaignComponent.dossierCampaignDetailComponent.approvedAmount"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_APPROVED`)}
                    placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_APPROVED`)}
                    component={InputMoney}
                    disabled={readOnlyFields || !amountFreeOption || this.state.fieldsConfiguration.approvedAmount.permission === permissions.readOnly}
                  />)}
              </Row>
              {this.state.fieldsConfiguration.bonified.permission !== permissions.hidden && (
                <Field
                  id="bonified"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.bonified"
                  colSm={12}
                  componentClass="textarea"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.BONIFIED`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.BONIFIED`)}
                  component={InputText}
                  disabled={true}
                  resize = "none"
                />)}
              {this.state.fieldsConfiguration.observations.permission !== permissions.hidden && (
                <Field
                  id="observations"
                  name="dossierCampaignComponent.dossierCampaignDetailComponent.observations"
                  colSm={12}
                  componentClass="textarea"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.OBSERVATIONS`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.OBSERVATIONS`)}
                  component={InputText}
                  disabled={true}
                  resize = "none"
                />
              )}
              {this.state.fieldsConfiguration.vehiclePrice.permission !== permissions.hidden && (
                <Field
                  id="vehiclePrice"
                  name="dossierCampaignComponent.vehiclePrice"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.VEHICLE_PRICE`)}
                  component={InputMoney}
                  disabled={true}
                />
              )}
              {this.state.fieldsConfiguration.vehicleOptionalsPrice.permission !== permissions.hidden && (
                <Field
                  id="vehicleOptionalsPrice"
                  name="dossierCampaignComponent.vehicleOptionalsPrice"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.VEHICLE_OPTIONALS_PRICE`)}
                  component={InputMoney}
                  disabled={true}
                />
              )}
              {this.state.fieldsConfiguration.billingNumber.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="BillingNumber"
                  name='dossierCampaignComponent.billingNumber'
                  key='dossierCampaignComponent.billingNumber'
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.BILLING_NUMBER`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.BILLING_NUMBER`)}
                  component={InputText}
                  type="text"
                  disabled={readOnlyFields || this.state.fieldsConfiguration.billingNumber.permission !== permissions.editable}
                />
              )}
              {this.state.fieldsConfiguration.billingDate.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="BillingDate"
                  name="dossierCampaignComponent.billingDate"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.BILLING_DATE`)}
                  component={InputDatePicker}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.billingDate.permission !== permissions.editable}
                />
              )}
              <div className="clearfix" />
              {this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden ? (
                <Tabs
                  id="1"
                  defaultActiveKey={1}
                  activeKey={this.state.tabActiveKey}
                  onSelect={tabActiveKey => { this.setState({ tabActiveKey }); this.props.actions.savePercentages(tabActiveKey) }}>
                  <Tab eventKey={1} title={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.INTRODUCE_AMOUNT`)} className="dossier-tab">
                    {this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden && (
                      <Field
                        id="amount_amount"
                        name="dossierCampaignComponent.amount"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT`)}
                        component={InputMoney}
                        disabled={readOnlyFields || this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden}
                        onInputBlur={(event) => this.handleBlurAmount(event)}
                      />
                    )}
                    {this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden && (
                      <Field
                        id="amount_amountPercentage"
                        name="dossierCampaignComponent.amountPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_PERCENTAGE`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_PERCENTAGE`)}
                        popOver={ this.state.fieldsConfiguration.popOverCampaings.permission !== permissions.hidden ? <CampaignsPopover id="campaignsPopover" name="campaignsPopover" key="campaignsPopover" t={t} text={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_PERCENTAGE`) } /> : null}
                        component={InputPercentage}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.cost.permission !== permissions.hidden && (
                      <Field
                        id="amount_cost"
                        name="dossierCampaignComponent.cost"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST`)}
                        component={InputMoney}
                        disabled={readOnlyFields || this.state.fieldsConfiguration.cost.permission !== permissions.editable}
                        onInputBlur={(event) => this.handleBlurCost(event)}
                      />
                    )}
                    {this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden && (
                      <Field
                        id="amount_costPercentage"
                        name="dossierCampaignComponent.costPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_PERCENTAGE`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_PERCENTAGE`)}
                        component={InputPercentage}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden && (
                      <Field
                        id="amount_costConcession"
                        name="dossierCampaignComponent.costConcession"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION`)}
                        component={InputMoney}
                        disabled={readOnlyFields || this.state.fieldsConfiguration.costConcession.permission !== permissions.editable}
                        onInputBlur={(event) => this.handleBlurCostConcession(event)}
                      />
                    )}
                    {this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden && (
                      <Field
                        id="amount_costConcessionPercentage"
                        name="dossierCampaignComponent.costConcessionPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION_PERCENTAGE`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION_PERCENTAGE`)}
                        component={InputPercentage}
                        disabled={true}
                      />
                    )}
                  </Tab>
                  <Tab eventKey={2} title={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.INTRODUCE_PERCENTAGE`)} className="dossier-tab">
                    {this.state.fieldsConfiguration.amount.permission !== permissions.hidden && (
                      <Field
                        id="amount"
                        name="dossierCampaignComponent.amount"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT`)}
                        component={InputMoney}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden && (
                      <Field
                        id="amountPercentage"
                        name="dossierCampaignComponent.amountPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_PERCENTAGE`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_PERCENTAGE`)}
                        component={InputPercentage}
                        onInputBlur={(component) => this.handleBlurAmountPercentage(component)}
                        popOver={ this.state.fieldsConfiguration.popOverCampaings.permission !== permissions.hidden ? <CampaignsPopover id="campaignsPopover" name="campaignsPopover" key="campaignsPopover" t={t} text={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT_PERCENTAGE`) } /> : null}
                        disabled={readOnlyFields || this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden}
                      />
                    )}
                    {this.state.fieldsConfiguration.cost.permission !== permissions.hidden && (
                      <Field
                        id="cost"
                        name="dossierCampaignComponent.cost"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST`)}
                        component={InputMoney}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden && (
                      <Field
                        id="costPercentage"
                        name="dossierCampaignComponent.costPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_PERCENTAGE`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_PERCENTAGE`)}
                        component={InputPercentage}
                        disabled={readOnlyFields || this.state.fieldsConfiguration.costPercentage.permission !== permissions.editable}
                        onInputBlur={(component) => this.handleBlurCostPercentage(component)}
                      />
                    )}
                    {this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden && (
                      <Field
                        id="costConcession"
                        name="dossierCampaignComponent.costConcession"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION`)}
                        component={InputMoney}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden && (
                      <Field
                        id="costConcessionPercentage"
                        name="dossierCampaignComponent.costConcessionPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION_PERCENTAGE`)}
                        placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST_CONCESSION_PERCENTAGE`)}
                        component={InputPercentage}
                        disabled={readOnlyFields || this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.editable}
                        onInputBlur={(component) => this.handleBlurCostConcessionPercentage(component)} k
                      />
                    )}
                  </Tab>
                </Tabs>) : this.state.fieldsConfiguration.amountCost.permission !== permissions.hidden && ([
                this.state.fieldsConfiguration.amount.permission !== permissions.hidden && (
                  <Field
                    id="amount"
                    key="amount"
                    name="dossierCampaignComponent.amount"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT`)}
                    placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.AMOUNT`)}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.amount.permission !== permissions.editable}
                    component={InputMoney}
                  />),
                this.state.fieldsConfiguration.cost.permission !== permissions.hidden && (
                  <Field
                    id="cost"
                    key="cost"
                    name="dossierCampaignComponent.cost"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST`)}
                    placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.COST`)}
                    component={InputMoney}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.cost.permission !== permissions.editable}
                  />)
              ])}
              {this.state.fieldsConfiguration.documentIds.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="documentIds"
                  name="dossierCampaignComponent.documentIds"
                  multi
                  controlLabel={t(`${tKey}CAMPAIGNS.CAMPAIGNS_MODAL.CHECKLIST`)}
                  placeholder={t(`${tKey}CAMPAIGNS.CAMPAIGNS_MODAL.CHECKLIST`)}
                  component={InputSelect}
                  options={documentsTypes}
                  // onInputChange={(value) => this.handleCampaign(value)}
                  valueKey="id"
                  labelKey="value"
                  disabled={!checklistEditable || this.state.fieldsConfiguration.documentIds.permission !== permissions.editable}
                />
              )}
              {this.state.fieldsConfiguration.expirationDate.permission !== permissions.hidden && (
                <Field
                  id="expirationDate"
                  name="dossierCampaignComponent.expirationDate"
                  colSm={6}
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.EXPIRATION_DATE`)}
                  component={InputDatePicker}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.expirationDate.permission !== permissions.editable}
                  validate={[this.dateValidation]}
                />
              )}
              {this.state.fieldsConfiguration.paymentMethodCampaign.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="paymentMethodCampaignId"
                  name="dossierCampaignComponent.paymentMethodCampaignId"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.PAYMENT_METHOD`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.PAYMENT_METHOD`)}
                  component={InputSelect}
                  options={paymentMethodCampaignCombo}
                  valueKey="id"
                  labelKey="value"
                  isClearable={false}
                  disabled={readOnlyFields || filledBillingDateAndNumberInParent || this.state.fieldsConfiguration.paymentMethodCampaign.permission !== permissions.editable}
                />
              )}
              <div className="clearfix" />
              {this.state.fieldsConfiguration.checkInvoiceProform.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="checkInvoiceProform"
                  name="dossierCampaignComponent.checkInvoiceProform"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CHECK_INVOICE_PROFORM`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CHECK_INVOICE_PROFORM`)}
                  component={InputCheckBox}
                  disabled={this.state.fieldsConfiguration.checkInvoiceProform.permission === permissions.readOnly}
                />
              )}
              <div className="clearfix" />
              {this.state.fieldsConfiguration.checkBillingRequested.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="checkBillingRequested"
                  name="dossierCampaignComponent.checkBillingRequested"
                  controlLabel={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CHECK_BILLING_REQUESTED`)}
                  placeholder={t(`${tKey}CAMPAIGN_DOSSIER.CAMPAIGN_COMPONENT.CHECK_BILLING_REQUESTED`)}
                  component={InputCheckBox}
                  disabled={true}
                />
              )}
            </Row>
            <CustomFields customFields={customFields} readOnlyFields={readOnlyFields} />
          </Panel.Collapse>
        </Panel>
      </Row>
    )
  }
}

export default CampaignComponent
